const { default: push } = require("../../datalayer/utils/push");

(function(window) {
    if ($('.site-header').length <= 0) {
        return;
    }

    $navSearchToggler = $('.site-header__desktop-search-tigger');
    $navSearchTogglerMobile = $('.site-header__mobile-search-tigger');
    $siteHeaderSearch = $('.site-header__search');
    $jsCloseHeaderSearch = $('.js-close-search');
    $jsResetSearch = $('.js-reset-search');
    $jsSearchSubmit = $('.js-search-submit');
    $searchInput = $('.site-header__search input');

    function toggleNavSearch(e) {
        e.preventDefault();
        $siteHeaderSearch.toggleClass('active');
        $navSearchToggler.toggleClass('active');
        $navSearchTogglerMobile.toggleClass('active');
    }

    function resetSearch(e) {
        e.preventDefault();
        $jsResetSearch.removeClass('active');

        $searchInput.val('');
        $searchInput.focus();
    }

    function submitSearch(e) {
        e.preventDefault();
        push({'event': 'searchEvent', 'searchQuery': $('[data-search-page]').val()});
        let dataSearchPage = $('[data-search-page]').attr('data-search-page');
        let inputValue = $('[data-search-page]').val();
        let base_url = window.location.origin;
        let url = base_url + dataSearchPage + '?searchTerm=' + inputValue;
        window.location = url;
    }

    $jsCloseHeaderSearch.on('keypress', toggleNavSearch);
    $jsCloseHeaderSearch.on('click', toggleNavSearch);

    $navSearchToggler.on('keypress', toggleNavSearch);
    $navSearchToggler.on('click', toggleNavSearch);

    $navSearchTogglerMobile.on('keypress', toggleNavSearch);
    $navSearchTogglerMobile.on('click', toggleNavSearch);

    $jsResetSearch.on('keypress', resetSearch);
    $jsResetSearch.on('click', resetSearch);

    $jsSearchSubmit.on('keypress', submitSearch);
    $jsSearchSubmit.on('click', submitSearch);

    $('.site-header__search input').keyup(function(e) {
        e.preventDefault();
        var dInput = this.value;
        if (dInput.length > 0) {
            $jsResetSearch.addClass('active');
            if (e.which == 13) {
                $jsSearchSubmit.click();
            }
        } else {
            $jsResetSearch.removeClass('active');
        }
    });
})(window);

window.addEventListener('load', function(event) {
    function scrollToTargetAdjusted() {
        let newHash = window.location.hash;
        if (newHash) {
            let element = document.querySelector(newHash);
            let headerOffset = 150;
            if (window.innerWidth < 992) {
                headerOffset = 30;
            }
            let elementPosition = element.getBoundingClientRect().top;
            let offsetPosition =
                elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    }

    setTimeout(function() {
        scrollToTargetAdjusted();
    }, 200);

    document.addEventListener(
        'click',
        function(event) {
            // If the clicked element doesn't have the right selector, bail
            if (!event.target.matches('a')) return;
            setTimeout(function() {
                scrollToTargetAdjusted();
            }, 50);
        },
        false
    );
});
